
import tasksApi from '@/api/tasks';

export default {
  name: 'PlanTaskSelect',

  props: {
    value: {
      type: String | null,
      required: true,
    },
    plan_uuid: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      loading: true,
      tasks: [],
    };
  },

  computed: {
    selectedList: {
      get: function () {
        if (this.value) {
          return this.tasks.filter((item) => this.value.includes(item.uuid));
        }
      },
      set: function (newVal) {
        if (newVal) {
          this.$emit('input', newVal.uuid);
        } else {
          this.$emit('input', null);
        }
      },
    },
  },

  methods: {
    getTasks(plan_uuid) {
      this.loading = true;
      tasksApi
        .getAllTasks({
          params: {
            'filter[taskable_uuid]': plan_uuid,
            'filter[taskable_type]': 'plan',
            'filter[show_child_tasks]': true,
            per_page: 250,
          },
        })
        .then((rsp) => {
          this.tasks = rsp.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$nuxt.$emit('notification', err.response.data.message, 'warning', true);
        });
    },
  },

  watch: {
    plan_uuid(new_val) {
      if (new_val !== null && new_val !== undefined) {
        this.getTasks(new_val);
      }
    },
  },
};
